import { MxheroShareConfig } from "@dashboard-v3/api";
import { MenuItem, SelectProps, Typography } from "@material-ui/core";
import SelectField from "components/Forms/SelectField";
import { useTranslation } from "react-i18next";

interface RetentionProps {
  disabled: boolean;
  value: string;
  onChange: (update: Partial<MxheroShareConfig>) => void;
}

type Retention = MxheroShareConfig["retention"];

// Same order as shareRetentions in the API, which the web only imports as a type.
const retentions: Array<[Retention, string]> = [
  ["SEVEN_DAYS", "7 days"],
  ["FOURTEEN_DAYS", "14 days"],
  ["THIRTY_DAYS", "30 days"],
  ["SIXTY_DAYS", "60 days"],
  ["NINETY_DAYS", "90 days"],
  ["ONE_HUNDRED_EIGHTY_DAYS", "180 days"],
  ["ONE_YEAR", "1 year"],
  ["TWO_YEARS", "2 years"],
  ["THREE_YEARS", "3 years"],
  ["FOUR_YEARS", "4 years"],
  ["FIVE_YEARS", "5 years"],
  ["SIX_YEARS", "6 years"],
  ["SEVEN_YEARS", "7 years"],
  ["TEN_YEARS", "10 years"],
  ["PERMANENT", "Permanent"],
];

export default function RetentionOptions(props: RetentionProps) {
  const { t } = useTranslation("mxheroShares");
  const { value, disabled } = props;

  const onChange: SelectProps["onChange"] = e => {
    props.onChange({ retention: e.target.value as Retention });
  };

  return (
    <div style={{ maxWidth: "50%" }}>
      <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
        {t("settings.retention.title")}
      </Typography>
      <SelectField
        fullWidth={false}
        disabled={disabled}
        options={retentions}
        style={{ width: "250px" }}
        value={value}
        onChange={onChange}
        data-testid="shares-retention"
        renderOption={([retention, label]) => (
          <MenuItem key={retention} value={retention}>
            {t(`settings.retention.${retention}`, label) as string}
          </MenuItem>
        )}
      />
      <Typography
        variant="caption"
        color="textSecondary"
        component="p"
        style={{ marginTop: 4 }}
      >
        {t(
          "settings.retention.help",
          "Applies to emails processed from now on. Files already stored keep their period. Each rule can set its own period."
        )}
      </Typography>
    </div>
  );
}
